import { supabase } from '../supabaseClient';
import { isEventListed } from '../utils/eventType';
import { PROFILE_EVENTS_SELECT } from './profiles';
import { isEventOver } from '../utils/eventCutoff';
import { isEventCancelled } from '../utils/eventStatus';

export async function fetchMyRsvps(userId) {
  const { data, error } = await supabase
    .from('rsvps')
    .select('event_id, status, events!fk_rsvps_event(event_type, festival_ready)')
    .eq('user_id', userId);
  if (error) throw error;
  // An RSVP to a festival the feed hides is not one you can see anywhere else, so Sets and Groups skip it too.
  return (data ?? [])
    .filter((r) => isEventListed(r.events))
    .map(({ event_id, status }) => ({ event_id, status }));
}

/** The events you are going to that are not over, soonest first - the head of the Events list (Sam, 2026-10-28). */
export async function fetchMyGoingEvents(eventIds) {
  if (!eventIds?.length) return [];
  const { data, error } = await supabase
    .from('events')
    .select(PROFILE_EVENTS_SELECT)
    .in('event_id', eventIds);
  if (error) throw error;
  return (data ?? [])
    .filter((e) => isEventListed(e) && !isEventOver(e) && !isEventCancelled(e))
    .sort(
      (a, b) =>
        new Date(a.event_datetime || a.event_date) - new Date(b.event_datetime || b.event_date),
    );
}
